<script lang="ts" setup></script>

<template>
  <UiDialog class="max-w-5xl">
    <template #default="{ close }">
      <button class="ml-auto block" @click="close">
        <Icon name="fa6-solid:xmark" class="size-8"></Icon>
      </button>
      <div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img src="/img/Arris.png" class="mx-auto w-full max-w-xs" />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">
              Multimediální Centrum Arris VIP7300
            </p>
            <p class="">
              Nejmodernější set-top-box k naší IPTV službě s operačním systémem
              AndroidTV. STB má předinstalovanou aplikaci Genius TV, HBO MAX,
              Netflix a Disney+. Další aplikace jsou přístupné skrz Google play.
              STB zvládá rozlišení až UltraHD.
            </p>
            <p>K naší TV můžete STB získat za pouhých 99 Kč s DPH měsíčně.</p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img src="/img/Setobox.png" class="mx-auto w-full max-w-xs" />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Set-top-box</p>
            <p class="">
              Nejpoužívanější a nejkvalitnější způsob pro přehrávání naší TV
              nabídky. Můžete si vybrat mezi fullHD STB v ceně 69 Kč s DPH
              měsíčně nebo UltraHD STB za pouhých 99 Kč s DPH.
            </p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img src="/img/Tizen.png" class="mx-auto w-full max-w-xs" />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Samsung Tizen</p>
            <p class="">
              Aplikaci pro SMART TV Samsung Tizen (2018-2024) naleznete zdarma
              ke stažení v Samsung Store pod názvem Genius TV.
            </p>
            <p class="text-xs">*Společnost GRAPE SC neručí za kompatibilitu.</p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img src="public/img/LG.png" class="mx-auto w-full max-w-xs" />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">LG TV</p>
            <p class="">
              Aplikaci pro SMART TV LG TV (webOS 4 a vyšší, TV 2018-2024)
              naleznete zdarma ke stažení v obchodě LG pod názvem Genius TV.
            </p>
            <p class="text-xs">*Společnost GRAPE SC neručí za kompatibilitu.</p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <div class="w-full max-w-xs">
            <img src="/img/android.png" class="mx-auto w-full max-w-xs" />
            <img src="/img/google.png" class="mx-auto w-full max-w-xs" />
          </div>
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Android TV / Google TV</p>
            <p class="">
              Aplikaci pro Android TV / Google TV naleznete zdarma ke stažení v
              Google Play pod názvem Genius TV - AndroidTV
            </p>
            <p class="">
              Vyzkoušeli jsme za Vás několik zařízeních nahrazující SMART TV.
              Recenze zde
            </p>
            <p class="text-xs">*Společnost GRAPE SC neručí za kompatibilitu.</p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img src="/img/PC.png" class="mx-auto w-full max-w-xs" />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Počítač</p>
            <p class="">
              Pro sledování Vašich oblíbených televizních stanic v počítači
              přejděte na stránku tv.grapesc.cz
            </p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img
            src="https://play.google.com/intl/en_us/badges/images/apps/en-play-badge.png"
            class="mx-auto w-full max-w-xs"
          />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Mobilní telefon - Android</p>
            <p class="">
              Aplikaci pro mobilní telefony s operačním systémem Android
              naleznete zdarma ke stažení v Google Play pod názvem Genius TV
            </p>
          </div>
        </div>
        <div class="flex items-center gap-5 py-5 max-md:flex-col">
          <img
            src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png"
            class="mx-auto w-full max-w-xs"
          />
          <div class="flex flex-col gap-2">
            <p class="text-2xl font-bold">Mobilní telefon - Apple</p>
            <p class="">
              Aplikaci pro mobilní telefony s operačním systémem iOS naleznete
              zdarma ke stažení v Apple Store pod názvem Genius TV
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #activator="{ open }">
      <button
        class="mx-auto block rounded-full bg-neutral-700 px-4 py-2 font-medium text-white"
        @click="open"
      >
        Podporované platformy
      </button>
    </template>
  </UiDialog>
</template>
